import { useEffect, useRef, useState } from 'react'
import { createModel } from 'hox'
import { TablePaginationConfig } from 'antd/es/table/interface'
import { DEFAULT_FIRST_PAGE_NUM, DEFAULT_PAGE_SIZE } from '@/utils/constants'
import { IVehicleDetail, IVehicleSearchFields, vehicleService } from './vehicleService'
import useGlobalModel, { transPgToPagination } from '@/model/globalModel'
import { ISearchPage } from '@/types/AppTypes'
import { globalPrompt } from '@/components/message'
import { ModoulTypeList } from '@/types/TcoDs'
import { message } from 'antd'
import { convertRes2Blob } from '@/utils/exportFile'

export const baseVehicleModel = createModel(function() {
    const settingTypeList = ModoulTypeList
    /**
     * 列表
     */
        //列表数据源
    const [dataSource, setDataSource] = useState<IVehicleDetail[]>([])
    //查询条件
    const [searchParam, setSearchParam] = useState<IVehicleSearchFields>({})
    //新增详情form
    const [detailAddForm, setDetailAddForm] = useState<IVehicleDetail>({})
    //编辑详情form
    const [detailEditForm, setDetailEditForm] = useState<IVehicleDetail>({})
    //分页参数
    const initPgCfg: TablePaginationConfig = { pageSize: DEFAULT_PAGE_SIZE, current: DEFAULT_FIRST_PAGE_NUM }
    const [pgCfg, setPgCfg] = useState<TablePaginationConfig>(initPgCfg)
    //表格多选id值
    const [selectedRowKeys, setSelectedRowKeys] = useState<IVehicleDetail[]>([])
    const [SelectedId, setSelectedId] = useState('')
    //对账明细打开页面
    const [detailVisible, setDetailVisible] = useState(false)
    //新增，编辑状态判断
    const [mode, setMode] = useState<'add' | 'edit'>('add')
    //对账明细打开页面
    const [addCarVisible, setAddCarVisible] = useState(false)
    const [editCarVisible, setEditCarVisible] = useState<any>({
        visible: false,
        value: {}
    })

    const pgCfgRef = useRef<TablePaginationConfig>(initPgCfg)
    //新增详情form
    const [totalNum, setTotalNum] = useState<any>({})
    const { user: { shopCode, createUser, userType }, fetchVehicleList } = useGlobalModel(({ user }) => [user])
    const [loading, setLoading] = useState<boolean>(false)
    useEffect(() => {
        pgCfgRef.current = pgCfg
    }, [pgCfg])
    //列表查询
    const loadData = async (page: ISearchPage = pgCfgRef.current, searchValue: IVehicleSearchFields = searchParam) => {
        setLoading(true)

        const searchParams = {
            ...searchValue,
            createUserId: shopCode,
            type: '卡车',
            vehicleSite: userType === '管理员' ? createUser : undefined,
            retrieveName: userType === '司机' || userType === '押运员' ? createUser : undefined,
            pageSize: page?.pageSize ?? pgCfg.pageSize ?? DEFAULT_PAGE_SIZE,
            pageNum: (page?.current || page?.pageNum) ?? DEFAULT_FIRST_PAGE_NUM
        }
        let { retData } = await vehicleService.page(searchParams)
        const { records, ...pg } = retData
        setPgCfg(transPgToPagination(pg))
        // setPgCfg(transPgToPagination({ total: records.length, size: 100, current: 1 }))
        setDataSource(records)
        // let { retData: totalList } = await vehicleService.getTotal(shopCode)
        // setTotalNum(totalList)
        setLoading(false)
        fetchVehicleList()
    }
    //设置搜索value
    const updateSearchParam = (updateParam: IVehicleSearchFields) => {
        setSearchParam({ ...searchParam, ...updateParam })
    }

    //明细下载模板
    const downloadMB = async () => {
        let result = await vehicleService.downloadMB()
        convertRes2Blob(result)
    }

    //重置搜索参数
    const resetSearchParam = () => {
        setSearchParam({})
        setSelectedRowKeys([])
        loadData(initPgCfg, {}).then(() => {
        })
    }
    //删除车辆
    const onDelete = (record: IVehicleDetail) => {
        globalPrompt('modal', {
            title: '删除车辆',
            type: 'warning',
            text: '您正在删除车辆是否确认删除？',
            okText: '确认',
            onOk: async () => {
                let list = record.map((item: any) => {
                    return { id: item.id }
                })
                let insertRet = await vehicleService.onDelete(list)
                if (insertRet.success) {
                    message.success('删除成功!')
                } else {
                    message.success('删除失败!' + insertRet.retMsg)
                }
                await loadData()
            },
            cancelText: '取消',
            onCancel: () => {
                return
            }
        })
    }
    return {
        /***field***/
        searchParam,
        dataSource,
        selectedRowKeys,
        pgCfg,
        detailVisible,
        detailEditForm,
        detailAddForm,
        mode,
        SelectedId,
        settingTypeList,
        totalNum,
        loading,
        addCarVisible,
        editCarVisible,
        initPgCfg,
        /***method***/
        setEditCarVisible,
        setAddCarVisible,
        setLoading,
        setTotalNum,
        setDataSource,
        setSelectedRowKeys,
        resetSearchParam,
        updateSearchParam,
        loadData,
        setDetailVisible,
        setDetailEditForm,
        setDetailAddForm,
        setMode,
        setSelectedId,
        onDelete,
        downloadMB
    }
})
